import { useContext } from 'react'

import { ThemeContext } from './ThemeContextProvider'

export const useThemeContext = () => {
  const context = useContext(ThemeContext)

  if (!context) {
    throw new Error(
      'You forgot to wrap your component in <RefinedThemeContextProvider>',
    )
  }

  return context
}
